//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'IVDripRate_info'

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/IVDripRate_info.vue